<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';
	//Design system components
	import { AdvancedCard, CardGrid, IconButton } from '@Shelly/shelly-design-system';
	//Stores
	import { selected_for_car_play } from 'src/stores/features/car-play';
	import { devices } from 'src/stores/lists/devices';

	//Helpers
	import { dndHandleClick } from 'src/components/Lists/list-helpers';
	import EmptyList from 'src/components/Lists/EmptyList.svelte';
	import { load_image_from } from 'src/helpers/interface_helpers';

	const flipDurationMs = 0;

	$: editDevices = $selected_for_car_play
		.filter((device) => $devices[device] !== undefined)
		.map((device) => {
			//getting the device object from the store
			return $devices[device];
		});

	$: dndSettings = {
		items: editDevices,
		dragDisabled: true,
	}; //dndSettings preventing dragging and reordering devices working over the cards. THe button is still clickable

	//#region Reorder
	const handleReorder = (e: CustomEvent) => {
		editDevices = e.detail.items; //reordering list of devices while dragging
	};

	const handleReorderEnd = async (e: CustomEvent) => {
		let editedList = {};
		e.detail.items.map((v, i) => {
			delete v?.isDndShadowItem;

			editedList[v.id] = {
				...v,
				position: i,
			};
		});

		if (Object.keys(editedList).length === 0) return;

		editDevices = [...e.detail.items];
		selected_for_car_play.set(editDevices.map((device) => device.id)); //updating the store with the new order on drag end
	};

	const handleStartDrag = (e) => {
		dndHandleClick(e, false);
		dndSettings.dragDisabled = false; //allowing reordering of the cards after button click
	};

	const handleEndDrag = (e) => {
		dndHandleClick(e, false);
		dndSettings.dragDisabled = true; //preventing reordering of the cards after button is released
	};

	//#endregion Reorder
</script>

{#if !editDevices.length}
	<EmptyList
		withoutMargin
		type="modal"
		title={$format('title_no_selected_carplay_devices', {
			default: 'There are no CarPlay selected devices',
		})}
		description={$format('on_board_select_devices_description', {
			default:
				'Currently you don’t have selected CarPlay devices. Please select devices on the next step.',
		})}
	/>
{:else}
	<CardGrid
		sm={170}
		md={200}
		lg={350}
		gridGap="s"
		modalContent
		noPaddingBottom
		{dndSettings}
		on:consider={handleReorder}
		on:finalize={handleReorderEnd}
	>
		{#each editDevices as device (device.id)}
			<div
				class:dnd-placeholder={device.isDndShadowItem}
				tabindex="0"
				role="button"
				aria-label={$format('button_drag_device_to_reorder', {
					default: 'Drag device to reorder',
				})}
			>
				<AdvancedCard
					avatar={{
						image: load_image_from(device.image, device?.server),
					}}
					title={device.name}
					selected={false}
					isFocusable={false}
					tabindex="-1"
				>
					<IconButton
						aria-label={$format('button_drag_to_reorder', { default: 'Drag to reorder' })}
						class="mt-m mb-m mr-s"
						icon="fas fa-up-down-left-right"
						slot="right"
						on:mousedown={handleStartDrag}
						on:touchstart={handleStartDrag}
						on:mouseup={handleEndDrag}
						on:touchend={handleEndDrag}
						dndHandle
					/>
				</AdvancedCard>
			</div>
		{/each}
	</CardGrid>
{/if}
